// extracted by mini-css-extract-plugin
module.exports = {"placeholderWrapper":"placeholderWrapper___uWiyA"};